"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Dropdown", {
    enumerable: true,
    get: function() {
        return Dropdown;
    }
});
var Dropdown = {
    baseStyle: {
        list: {
            borderRadius: "radii-card",
            paddingX: "0",
            paddingY: "1rem",
            boxShadow: "elevation-interactive",
            border: "none",
            backgroundColor: "background-card"
        },
        item: {
            color: "text-primary",
            textStyle: "text-body-regular",
            paddingX: "1rem",
            paddingTop: "0.5rem",
            paddingBottom: "0.5rem"
        }
    }
};
